<template>
  <div>
    <v-dialog v-model="show" persistent max-width="600px" width="600px">
      <v-overlay :absolute="absolute" :value="overlay"> <v-progress-circular indeterminate size="64"></v-progress-circular> </v-overlay>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>اضافة وصل جديد</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <div style="margin-top: 10px"></div>
          <v-row>
            <v-col cols="6">
              <h4>قسط القسم : {{ sectionInstallment }}</h4></v-col
            >
            <v-col cols="6">
              <h4>المتبقي : {{ remaining }}</h4></v-col
            >
          </v-row>

          <div style="margin-top: 10px"></div>

          <!-- <v-text-field v-model="comPort" label="منفذ المعالج" outlined></v-text-field> -->
          

          <v-autocomplete
            v-model="payType"
            outlined
            label="نوع الدفع"
            :rules="studentRequiredFormRules"
            :items="payTypes"
          ></v-autocomplete>


          <v-autocomplete
            v-model="paymentTypeId"
            outlined
            label="الدفعة"
            :rules="studentRequiredFormRules"
            :items="paymentTypesAll"
            item-text="typeName"
            item-value="idPaymentType"
            @change="identityChosen()"
          ></v-autocomplete>

          <vuetify-money
            v-model="amount"
            v-bind:label="label"
            :rules="studentRequiredFormRules"
            v-bind:placeholder="placeholder"
            v-bind:readonly="readonly"
            v-bind:disabled="disabled"
            v-bind:outlined="outlined"
            v-bind:clearable="clearable"
            v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
            v-bind:options="options"
          />

          <v-textarea v-model="payNote" outlined name="input-7-4" label="الملاحظات"></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="saveData" v-on:keyup.enter="saveData"> حفظ </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-2" color="primary" @click="show = true" v-bind="attrs" v-on="on">
          <v-icon dark> mdi-plus </v-icon>
          تسديد جديد
        </v-btn>
      </template>
      <span>اضافة وصل</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    studentPay: Object,
    sectionInstallment: Number,
    remaining: Number,
    paymentTypesAll: Array,
  },
  data: () => ({
    studentRequiredFormRules: [(v) => !!v || "حقل مطلوب . يرجى ادخال قيمة"],
    show: false,
    payTypeId: "",
    checkNumber: "",
    amount: 0,
    paymentTypesInstallment: [],
    payNote: "لايوجد",
    paymentTypeId: "",
    feesPay: "",
    absolute: true,
    overlay: false,
    payTypes: ["POS", "Cash"],
    payType: "",
    label: "المبلغ",
    placeholder: " ",
    readonly: false,
    disabled: false,
    outlined: true,
    comPort: "",
    clearable: true,
    valueWhenIsEmpty: "",
    options: {
      locale: "pt-BR",
      prefix: "IQ",
      suffix: "",
      length: 11,
      precision: 0,
    },
  }),
  created() {
    this.initialData();
    // $store.state.paymentTypesInstallment
    console.log(this.$store.state.paymentTypesAll);
  },
  methods: {
    initialData() {
      let self = this;
      let currentDate = new Date();
      console.log(currentDate.getDate());
    },

    identityChosen() {
      let self = this;
      console.log(self.paymentTypeId);
      if (self.paymentTypeId == 24) {
        self.amount = 50000;
      } else if (self.paymentTypeId == 34) {
        self.amount = 25000;
      } else if (self.paymentTypeId == 36) {
        self.amount = 25000;
      } else {
        self.amount = 0;
      }
    },

    async saveData() {
      let self = this;
      self.overlay = true;
      if(self.payType == "POS"){
        // Auto-detect COM port from COM1 to COM10
        let connectedPort = await self.autoDetectComPort();
        if(connectedPort) {
          self.comPort = connectedPort;
          self.processPosPayment();
        } else {
          self.overlay = false;
          this.$toasted.error("لم يتم العثور على جهاز ");
        }
      } else {
        self.processCashPayment();
      }
    },

    async autoDetectComPort() {
      let self = this;
      const comPorts = ['COM1', 'COM2', 'COM3', 'COM4', 'COM5', 'COM6', 'COM7', 'COM8', 'COM9', 'COM10'];
      
      for (let port of comPorts) {
        try {
          console.log(`جاري فحص المنفذ ${port}...`);
          const response = await self.$http.post(`http://localhost:9092/connectDeviceByUsb?comPort=${port}`);
          
          if (response.data.resultCode == 200) {
            console.log(`تم العثور على الجهاز في المنفذ ${port}`);
            return port;
          }
        } catch (error) {
          console.log(`فشل الاتصال بالمنفذ ${port}:`, error);
          // Continue to next port
        }
      }
      
      return null; // No port found
    },

    async processPosPayment() {
      let self = this;
      try {
        const subscribeResponse = await self.$http.post(`http://localhost:9092/subscribe?replyURL=http://localhost:9092/reply`);
        
        if(subscribeResponse.data.resultCode == 200){
          const requestResponse = await self.$http.post(`http://localhost:9092/createRequest`,{
            "CATEGORY":"com.pax.payment.Sale",
            "parm":{
              "amount":`${self.amount}000`,
              "tipAmount":0,
              "currencyCode":"IQD"
            }
          });
          
          if(requestResponse.data.resultCode == 200){
            if (self.paymentTypeId) {
              await self.saveStudentPayment("POS");
            }
          } else {
            self.overlay = false;
            this.show = false;
            this.$toasted.error("حدث خطأ في إنشاء طلب الدفع");
          }
        } else {
          self.overlay = false;
          this.show = false;
          this.$toasted.error("حدث خطأ في الاشتراك");
        }
      } catch (error) {
        console.log(error);
        self.overlay = false;
        this.show = false;
        this.$toasted.error("حدث خطأ في معالجة الدفع");
      }
    },

    async processCashPayment() {
      let self = this;
      if (self.paymentTypeId) {
        await self.saveStudentPayment("Cash");
      }
    },

    async saveStudentPayment(payType) {
      let self = this;
      try {
        const response = await self.$http.get(`${self.$store.state.apiUrlFees}/lastStudentPayment`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        });

        let voucherNumber;
        if (response.data.voucherNumber > 0) {
          voucherNumber = response.data.voucherNumber + 1;
        } else {
          voucherNumber = 1;
        }

        // Set payment date to 03-01-2026 (March 1, 2026)
        let currentDate = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`;
        
        // let fullDate = "2026-01-03";
        let fullDate = currentDate;

        let studentFees = {
          collegeNumber: self.$store.state.studentDetails.collegeNumber,
          paymentTypeId: self.paymentTypeId,
          studentLevel: self.$store.state.studentDetails?.level ? self.$store.state.studentDetails.level : 10,
          amount: self.amount,
          paymentDate: fullDate,
          notes: self.payNote,
          sectionId: self.$store.state.studentDetails.sectionId,
          studyYearId: 76,
          createdBy: self.$store.state.userData.idEmployee,
          isChecked: false,
          notValid: false,
          isReceived: false,
          voucherNumber: voucherNumber,
          isNewStudent: 0,
          payType: payType,
        };

        await this.$http.post(`${this.$store.state.apiUrlFees}/addStudentPayment`, studentFees, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        });

        await this.$http.put(
          `${this.$store.state.apiUrlRegistration}/studentStatus/${self.$store.state.studentDetails.idStudent}`,
          { oldStatus: self.$store.state.studentDetails.studentStatusId },
          {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }
        );

        self.overlay = false;
        this.show = false;
        this.$toasted.success("تم اضافه البيانات");
        this.$emit("reloadTask");

      } catch (error) {
        console.log(error);
        self.overlay = false;
        this.show = false;
        self.paymentTypeId = "";
        self.amount = 0;
        this.$toasted.error("حدث خطأ في البيانات");
      }
    }
  },
};
</script>

<style lang="scss" scoped></style>
